module.exports = __webpack_public_path__ + "img/1-3.b98a903b.png";